export const SyncStatus = {
  NOT_CONNECTED: 'NOT_CONNECTED',
  CONNECTED: 'CONNECTED',
  SYNCING: 'SYNCING',
  AUTHORIZED: 'AUTHORIZED',
  SYNC_ERROR: 'SYNC_ERROR'
};
